import { render, staticRenderFns } from "./RenameFieldsModel.vue?vue&type=template&id=18c0ba74&"
import script from "./RenameFieldsModel.vue?vue&type=script&lang=js&"
export * from "./RenameFieldsModel.vue?vue&type=script&lang=js&"
import style0 from "./RenameFieldsModel.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports